import { UrlHelper } from 'utilities/UrlHelper/UrlHelper';

import { Environment } from 'Environment';

const RPCModel = require('RPCModel');

const StorageProject = RPCModel.extend({
    className: 'MCS.Storage.Project',

    addUrl: 'projects/:pid/services/hotbox',
    findOneUrl: 'projects/:pid/services/hotbox',
    skipBonusUrl: 'hotbox/:pid/bonus/skip',

    /**
     * @type {Object}
     */
    defaults: {
        /**
         * Состояние доступности сервиса.
         * @type {string} – 'active', 'frozen' or 'suspended'
         */
        status: 'active',

        /**
         * Дата перевода сервиса в состояние 'frozen'.
         * @type {number} – TimeStamp (в секундах)
         */
        frozen_at: 0,

        /**
         * Дата перевода сервиса в состояние 'suspended'.
         * @type {number} – TimeStamp (в секундах)
         */
        suspended_at: 0,

        /**
         * Действующие лимиты.
         * @type {Object}
         */
        freeze: {
            /**
             * Баланс, при котором сервис
             * переводится в состояние 'frozen'.
             * @type {number} – в рублях (-0.01)
             */
            freeze_level: 0,

            /**
             * Максимальное время нахождения в состоянии 'frozen'.
             * @type {number} – в секундах
             */
            frozen_time: 0,

            /**
             * Баланс, при котором сервис
             * переводится в состояние 'suspended'.
             * @type {number} – в рублях (-1000)
             */
            suspend_level: 0,

            /**
             * Максимальное время нахождения в состоянии 'suspended'.
             * @type {number} – в секундах
             */
            suspended_time: 0,
        },

        bonus: {
            /**
             * Пройдены все задания.
             * @type {Boolean}
             */
            completed: false,

            /**
             * Пользователь пропустил прохождение заданий.
             * @type {Boolean}
             */
            skipped: false,

            /**
             * Список заданий.
             * @type {Arrayю.<Object>}
             */
            tasks: [
                {
                    /**
                     * Тип задания.
                     * @type {string}
                     */
                    id: 'enable',

                    /**
                     * Задание выполнено.
                     * @type {boolean}
                     */
                    completed: true,

                    /**
                     * Время окончания выполнения задания (в секундах).
                     * @type {number}
                     */
                    at: 0,
                },
                {
                    /**
                     * Тип задания.
                     * @type {string}
                     */
                    id: 'create_account',

                    /**
                     * Задание выполнено.
                     * @type {boolean}
                     */
                    completed: false,

                    /**
                     * Время окончания выполнения задания (в секундах).
                     * @type {number}
                     */
                    at: 0,
                },
                {
                    /**
                     * Тип задания.
                     * @type {string}
                     */
                    id: 'create_bucket',

                    /**
                     * Задание выполнено.
                     * @type {boolean}
                     */
                    completed: false,

                    /**
                     * Время окончания выполнения задания (в секундах).
                     * @type {number}
                     */
                    at: 0,
                },
                {
                    /**
                     * Тип задания.
                     * @type {string}
                     */
                    id: 'upload_object',

                    /**
                     * Задание выполнено.
                     * @type {boolean}
                     */
                    completed: false,

                    /**
                     * Время окончания выполнения задания (в секундах).
                     * @type {number}
                     */
                    at: 0,
                },
                {
                    /**
                     * Тип задания.
                     * @type {string}
                     */
                    id: 'share_public',

                    /**
                     * Задание выполнено.
                     * @type {boolean}
                     */
                    completed: false,

                    /**
                     * Время окончания выполнения задания (в секундах).
                     * @type {number}
                     */
                    at: 0,
                },
            ],
        },
    },

    parse(body) {
        this.meta('hasBonus', 'bonus' in body);

        return body;
    },

    prepareSendData() {
        return {
            metrics: Environment.utmParams,
        };
    },

    save() {
        return RPCModel.fn.save.call(this).then(() => {
            return this.expire().fetch();
        });
    },

    /**
     * Возвращает долг, по достижении которого сервис
     * переводится в состояние 'suspended'.
     * @returns {number} – в рублях
     */
    getSuspendDebt() {
        return this.get('freeze').suspend_level;
    },

    /**
     * @returns {number} – TimeStamp (в миллисекундах)
     */
    getSuspendDate() {
        const frozenAt = this.get('frozen_at');
        const frozenTime = this.get('freeze').frozen_time;

        return (frozenAt + frozenTime) * 1000;
    },

    getStatus() {
        return this.get('status').toLowerCase();
    },

    /**
     * Пропустить прохождение заданий.
     */
    skipBonus() {
        return this.queue((model) => {
            return model.request
                .post(StorageProject.url('skipBonus'))
                .then(() => {
                    model.set('bonus.skipped', true);
                });
        });
    },

    isLocked() {
        const status = this.getStatus();

        return status === 'frozen' || status === 'suspended';
    },
});

/**
 * Бонусная сумма (в рублях)
 * @static
 * @type {number}
 */
StorageProject.bonusAmount = 150;

StorageProject.url = UrlHelper.getModelUrlPidInjector();

export default StorageProject;
